import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";

export const apolloClient = new ApolloClient({
  // Apollo Client v4 no longer accepts the `uri` shorthand on the constructor;
  // configure an explicit HttpLink instead.
  link: new HttpLink({ uri: "/graphql" }),
  cache: new InMemoryCache(),
});
